export const FEED_ELEMENTS = {
  ASSIGNMENT: 'assignment',
  COMMENT: 'comment'
};
